"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpHandler = exports.ContentTypeJson = void 0;
var _facades = require("../facades");
var _tools = require("./tools");
var _jwt = _interopRequireDefault(require("../tools/jwt"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ContentTypeJson = exports.ContentTypeJson = 'application/json';
var HttpHandler = exports.HttpHandler = /*#__PURE__*/function () {
  function HttpHandler(apiUrl, getAccessToken, performRefresh) {
    var _this = this;
    _classCallCheck(this, HttpHandler);
    _defineProperty(this, "httpPost", function (path, body) {
      var useAuth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var contentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ContentTypeJson;
      var signal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var url = "".concat(_this.apiUrl).concat(path);
      var headers = contentType === null ? {} : {
        'content-type': contentType
      };
      if (useAuth) {
        return _this.authenticatedSend(url, 'POST', headers, body, signal);
      }
      return _this.send(url, 'POST', headers, body, signal);
    });
    _defineProperty(this, "httpPut", function (path, body) {
      var useAuth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var contentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ContentTypeJson;
      var signal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var url = "".concat(_this.apiUrl).concat(path);
      var headers = contentType === null ? {} : {
        'content-type': contentType
      };
      if (useAuth) {
        return _this.authenticatedSend(url, 'PUT', headers, body, signal);
      }
      return _this.send(url, 'PUT', headers, body, signal);
    });
    _defineProperty(this, "httpPatch", function (path, body) {
      var useAuth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var contentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ContentTypeJson;
      var signal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var url = "".concat(_this.apiUrl).concat(path);
      var headers = contentType === null ? {} : {
        'content-type': contentType
      };
      if (useAuth) {
        return _this.authenticatedSend(url, 'PATCH', headers, body, signal);
      }
      return _this.send(url, 'PATCH', headers, body, signal);
    });
    _defineProperty(this, "httpDelete", function (path, params) {
      var useAuth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var contentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ContentTypeJson;
      var signal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var url = "".concat(_this.apiUrl).concat(path).concat((0, _tools.jsonToQueryParams)(params));
      var headers = contentType === null ? {} : {
        'content-type': contentType
      };
      if (useAuth) {
        return _this.authenticatedSend(url, 'DELETE', headers, '', signal);
      }
      return _this.send(url, 'DELETE', headers, '', signal);
    });
    _defineProperty(this, "send", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url, method, headers) {
        var body,
          signal,
          payload,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              body = _args.length > 3 && _args[3] !== undefined ? _args[3] : '';
              signal = _args.length > 4 && _args[4] !== undefined ? _args[4] : null;
              // Mit dem folgenden Schnipsel kann man mobile das offline Verhalten testen.
              /*const now = new Date()
              const seconds = now.getSeconds()
              const minutes = now.getMinutes()
              if (minutes % 2 === 1) {
                console.log(`we are offline for ${60 - seconds} seconds`)
                throw new Error('misc_error_no_internet_message')
              }*/
              payload = {
                headers: _objectSpread({}, headers),
                // credentials: 'include',
                method: method
              };
              if (body) {
                payload.body = body;
              }
              if (signal) {
                payload.signal = signal;
              }
              _context.p = 1;
              _context.n = 2;
              return fetch(url, payload);
            case 2:
              return _context.a(2, _context.v);
            case 3:
              _context.p = 3;
              _t = _context.v;
              if (!(_t.message === 'Failed to fetch' || _t.message === 'Network request failed')) {
                _context.n = 4;
                break;
              }
              throw new Error('misc_error_no_internet_message');
            case 4:
              throw _t;
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(this, "authenticatedSend", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(url, method, headers) {
        var body,
          signal,
          accessToken,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              body = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : '';
              signal = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : null;
              _context2.n = 1;
              return _this.getAccessToken();
            case 1:
              accessToken = _context2.v;
              if (!accessToken) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return _this.validateTokenAndSendRequestIfValid(accessToken, url, method, headers, body, signal);
            case 2:
              return _context2.a(2, _context2.v);
            case 3:
              _context2.n = 4;
              return _this.refreshAccessTokenAndSendRequest(url, method, headers, body, signal);
            case 4:
              return _context2.a(2, _context2.v);
          }
        }, _callee2);
      }));
      return function (_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "currentTimeInUnix", function () {
      return (0, _facades.getUnixTime)(new Date());
    });
    _defineProperty(this, "tokenIsValid", function (tokenBody) {
      return tokenBody.exp > _this.currentTimeInUnix();
    });
    _defineProperty(this, "validateTokenAndSendRequestIfValid", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(accessToken, url, method, headers) {
        var body,
          signal,
          tokenBody,
          headersWithToken,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              body = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : '';
              signal = _args3.length > 5 && _args3[5] !== undefined ? _args3[5] : null;
              tokenBody = _jwt["default"].extractJwtBody(accessToken);
              if (!_this.tokenIsValid(tokenBody)) {
                _context3.n = 2;
                break;
              }
              headersWithToken = _objectSpread(_objectSpread({}, headers), {}, {
                authorization: "bearer ".concat(accessToken)
              });
              _context3.n = 1;
              return _this.send(url, method, headersWithToken, body, signal);
            case 1:
              return _context3.a(2, _context3.v);
            case 2:
              _context3.n = 3;
              return _this.refreshAccessTokenAndSendRequest(url, method, headers, body, signal);
            case 3:
              return _context3.a(2, _context3.v);
          }
        }, _callee3);
      }));
      return function (_x7, _x8, _x9, _x0) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(this, "refreshAccessTokenAndSendRequest", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(url, method, headers) {
        var body,
          signal,
          refreshSucceeded,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              body = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : '';
              signal = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : null;
              if (!_this.currentlyRefreshing) {
                _this.currentlyRefreshing = _this.performRefresh();
              }
              _context4.n = 1;
              return _this.currentlyRefreshing;
            case 1:
              refreshSucceeded = _context4.v;
              _this.currentlyRefreshing = null;
              if (!refreshSucceeded) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return _this.authenticatedSend(url, method, headers, body, signal);
            case 2:
              return _context4.a(2, _context4.v);
            case 3:
              return _context4.a(2, false);
          }
        }, _callee4);
      }));
      return function (_x1, _x10, _x11) {
        return _ref4.apply(this, arguments);
      };
    }());
    this.apiUrl = apiUrl;
    this.getAccessToken = getAccessToken;
    this.performRefresh = performRefresh;
  }
  return _createClass(HttpHandler, [{
    key: "httpGet",
    value: function httpGet(path, params) {
      var useAuth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var contentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ContentTypeJson;
      var signal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var url = "".concat(this.apiUrl).concat(path).concat((0, _tools.jsonToQueryParams)(params));
      var headers = contentType === null ? {} : {
        'content-type': contentType
      };
      if (useAuth) {
        return this.authenticatedSend(url, 'GET', headers, '', signal);
      }
      return this.send(url, 'GET', headers, '', signal);
    }
  }]);
}();